(function () {
	const initStickyAtc = () => {
		document.querySelectorAll(".sticky-atc").forEach((bar) => {
			if (bar.dataset.initialized) return;
			bar.dataset.initialized = "true";

			const sectionId = bar.dataset.section;
			const section = document.getElementById(`MainProduct-${sectionId}`);
			const mainSubmit = document.getElementById(
				`ProductSubmitButton-${sectionId}`
			);
			if (!section || !mainSubmit) return;

			const barPrice = bar.querySelector(".sticky-atc__price");
			const barButton = bar.querySelector(".sticky-atc__button");
			const barButtonLabel = barButton.querySelector(".button-label");

			// The Seal Subscriptions widget and the variant picker both replace
			// nodes inside the section when the selection changes, so re-query on
			// every sync instead of holding references
			// only write on change: the bar sits inside the observed section, so an
			// unconditional write would retrigger the observer forever
			const syncFromMainForm = () => {
				const priceSource = document.getElementById(`price-${sectionId}`);
				if (priceSource && barPrice) {
					const priceItem = priceSource.querySelector(
						".price-item--sale, .price-item--regular, .price-item"
					);
					const price = priceItem ? priceItem.textContent.trim() : "";
					if (price && barPrice.textContent !== price)
						barPrice.textContent = price;
				}
				if (barButton.disabled !== mainSubmit.disabled)
					barButton.disabled = mainSubmit.disabled;
				const mainLabel = mainSubmit.querySelector(".button-label");
				if (mainLabel && barButtonLabel) {
					const text = mainLabel.textContent.trim();
					if (text && barButtonLabel.textContent !== text)
						barButtonLabel.textContent = text;
				}
			};

			// A subscription is a recurring charge, so the shopper should see the purchase
			// options (price, terms, the cancel-anytime line and Shopify's consent text)
			// before committing to one. Until the options have been on screen, a tap on the
			// bar while a plan is selected scrolls to them instead of adding to cart.
			let optionsSeen = false;
			let seenObserver = null;
			let observedOptions = null;
			const purchaseOptions = () => section.querySelector(".sealsubs-container");
			// Seal renders late and replaces its container on variant changes, so
			// (re)attach whenever the observed node is missing or detached
			const watchPurchaseOptions = () => {
				if (optionsSeen) return;
				const options = purchaseOptions();
				if (!options || options === observedOptions) return;
				if (seenObserver) seenObserver.disconnect();
				observedOptions = options;
				seenObserver = new IntersectionObserver(
					(entries) => {
						if (!entries.some((entry) => entry.isIntersecting)) return;
						optionsSeen = true;
						seenObserver.disconnect();
					},
					{ threshold: 0.5 }
				);
				seenObserver.observe(options);
			};
			const subscriptionSelected = () => {
				const plan = mainSubmit.form
					? mainSubmit.form.querySelector('input[name="selling_plan"]')
					: null;
				return Boolean(plan && plan.value);
			};
			const scrollToPurchaseOptions = (options) => {
				const reduceMotion = window.matchMedia(
					"(prefers-reduced-motion: reduce)"
				).matches;
				// leave room for the header, which reappears when scrolling up
				const top = options.getBoundingClientRect().top + window.scrollY - 80;
				window.scrollTo({ top, behavior: reduceMotion ? "auto" : "smooth" });
				const selected = options.querySelector('[role="radio"][aria-checked="true"]');
				if (selected) selected.focus({ preventScroll: true });
			};

			syncFromMainForm();
			watchPurchaseOptions();
			const observer = new MutationObserver(() => {
				syncFromMainForm();
				watchPurchaseOptions();
			});
			observer.observe(section, {
				subtree: true,
				childList: true,
				characterData: true,
				attributes: true,
				attributeFilter: ["disabled"],
			});

			const visibility = new IntersectionObserver(
				([entry]) => {
					const shouldShow = !entry.isIntersecting;
					bar.classList.toggle("sticky-atc--visible", shouldShow);
					bar.setAttribute("aria-hidden", shouldShow ? "false" : "true");
				},
				{ rootMargin: "-80px 0px 0px 0px" }
			);
			visibility.observe(mainSubmit);

			barButton.addEventListener("click", () => {
				if (mainSubmit.disabled) return;
				const options = purchaseOptions();
				if (options && !optionsSeen && subscriptionSelected()) {
					scrollToPurchaseOptions(options);
					return;
				}
				mainSubmit.click();
			});
		});
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initStickyAtc);
	} else {
		initStickyAtc();
	}
	document.addEventListener("shopify:section:load", initStickyAtc);
})();
